/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseCategoriesCategoryIdNotFound
 */
export interface GetUniverseCategoriesCategoryIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseCategoriesCategoryIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseCategoriesCategoryIdNotFound interface.
 */
export function instanceOfGetUniverseCategoriesCategoryIdNotFound(value: object): value is GetUniverseCategoriesCategoryIdNotFound {
    return true;
}

export function GetUniverseCategoriesCategoryIdNotFoundFromJSON(json: any): GetUniverseCategoriesCategoryIdNotFound {
    return GetUniverseCategoriesCategoryIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseCategoriesCategoryIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseCategoriesCategoryIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseCategoriesCategoryIdNotFoundToJSON(json: any): GetUniverseCategoriesCategoryIdNotFound {
    return GetUniverseCategoriesCategoryIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseCategoriesCategoryIdNotFoundToJSONTyped(value?: GetUniverseCategoriesCategoryIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

